import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { Search, X } from "lucide-react";

type ToofiSidebarSearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  compact?: boolean;
};

export function ToofiSidebarSearch({
  value,
  onChange,
  placeholder = "Find a chat",
  compact = false,
}: ToofiSidebarSearchProps) {
  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-300">
        <Search className={cn(compact ? "h-3.5 w-3.5" : "h-4 w-4")} />
      </span>
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={cn(
          "rounded-full border-none bg-white/78 pl-9 pr-10 text-slate-700 shadow-[inset_0_1px_0_rgba(255,255,255,0.72)] outline-none ring-0 backdrop-blur-md focus:border-slate-300/80 focus:bg-white/88 focus:ring-0 focus-visible:border-slate-300/80 focus-visible:ring-0 focus-visible:ring-offset-0",
          compact ? "h-10 text-[13px]" : "h-11 text-[13px]",
        )}
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label="Clear chat search"
          className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      ) : null}
    </div>
  );
}
